export default {
  NATIVE_DATA: 'NATIVE_DATA',
  BRIDGE_TIMEOUT_ERR: 'Timeout! Unable to get Native Data',
  DOWNLOAD_ATTACHMENTS: 'DOWNLOAD_ATTACHMENTS',
  PRINT: 'PRINT',
};
